import {registerLocaleData} from '@angular/common';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import localeNl from '@angular/common/locales/nl';
import {ApplicationConfig, InjectionToken, LOCALE_ID} from '@angular/core';

export const MV_GATEWAY_URL = new InjectionToken<string>('Url voor mijnvacatures gateway');
export const DATUM_FORMAT = new InjectionToken<string>('Format wanneer datums getoond worden');

registerLocaleData(localeNl);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {provide: MV_GATEWAY_URL, useValue: '/webapps/mijnvacatures-gateway'},
    {provide: LOCALE_ID, useValue: 'nl-BE'},
    {provide: DATUM_FORMAT, useValue: 'dd-MM-yyyy'}
  ]
};
